var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSocialFb = function SvgSocialFb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.444 0H3.556A3.566 3.566 0 0 0 0 3.556v24.888C0 30.402 1.6 32 3.556 32H16V19.556h-3.556v-4.4H16V11.51c0-3.847 2.155-6.55 6.695-6.55l3.205.004v4.631h-2.128c-1.767 0-2.439 1.327-2.439 2.557v3.004H25.9l-1.01 4.399h-3.556V32h7.111A3.565 3.565 0 0 0 32 28.444V3.556C32 1.6 30.4 0 28.444 0Z"
  })));
};
export default SvgSocialFb;